import { all, call, put, takeEvery, throttle } from "redux-saga/effects";
import axios from "axios";
import { API_URL } from "../../utils/Constant";
import { HomePageActions } from "./action";

// 🧠 Utility function to safely call API
function* safeApiCall(url, successType) {
  try {
    const result = yield call(() => axios.get(url));
    yield put({ type: successType, payload: result.data });
  } catch (error) {
    console.error(`Error fetching ${url}:`, error);
  }
}

export const HomeSagas = function* () {
  yield all([
    // 🧩 Use throttle for frequently triggered requests
    throttle(5000, HomePageActions.GET_HOME_TOPBAR_SCROLL_TEXT, getHomeTopbarScrollText),
    throttle(5000, HomePageActions.GET_HOME_MENUS_AND_SUBMENUS, getHomeMenusAndSubmenus),

    // 🧩 takeEvery for static or one-time API calls
    takeEvery(HomePageActions.GET_HOME_HEADER_BANNER, getHomeHeaderBanner),
    takeEvery(HomePageActions.GET_HOME_BACKGROUNDIMAGE, getBackgroundImage),
    takeEvery(HomePageActions.GET_HOME_TESTIMONIAL, getTestimonial),
    takeEvery(HomePageActions.GET_HOME_ABOUTPRINCIPAL, getAboutPrincipal),
    takeEvery(HomePageActions.GET_HOME_LATESTVIDEO, getLatestVideo),
    takeEvery(HomePageActions.GET_HOME_BLOG, getBlog),
    takeEvery(HomePageActions.GET_HOME_STUDENTPORTFOLIO, getStudentPortfolio),
    takeEvery(HomePageActions.GET_HOME_NEWS_AND_EVENTS, getNewsAndEvents),
    takeEvery(HomePageActions.GET_DETAILPAGE, fetchDetailPage),
    takeEvery(HomePageActions.STUDENT_PORTFOLIO_DETAILPAGE, StudentPortfolioDetailPage),
    takeEvery(HomePageActions.GET_LISTPAGE_BACKGROUND_IMAGE, getListPageBGImage),
    takeEvery(HomePageActions.GET_SEO_IMAGE, getSeoImage),
  ]);
};

// ✅ Individual sagas — simplified

function* getHomeTopbarScrollText() {
  yield* safeApiCall(`${API_URL}/topbar`, HomePageActions.SET_HOME_TOPBAR_SCROLL_TEXT);
}

function* getHomeMenusAndSubmenus() {
  yield* safeApiCall(`${API_URL}/submenu`, HomePageActions.SET_HOME_MENUS_AND_SUBMENUS);
}

function* getHomeHeaderBanner() {
  yield* safeApiCall(`${API_URL}/banner`, HomePageActions.SET_HOME_HEADER_BANNER);
}

function* getBackgroundImage() {
  yield* safeApiCall(`${API_URL}/bg_banner`, HomePageActions.SET_HOME_BACKGROUNDIMAGE);
}

function* getTestimonial() {
  yield* safeApiCall(`${API_URL}/testimonials`, HomePageActions.SET_HOME_TESTIMONIAL);
}

function* getAboutPrincipal() {
  yield* safeApiCall(`${API_URL}/principal_message`, HomePageActions.SET_HOME_ABOUTPRINCIPAL);
}

function* getLatestVideo() {
  yield* safeApiCall(`${API_URL}/latest_videos`, HomePageActions.SET_HOME_LATESTVIDEO);
}

function* getBlog() {
  yield* safeApiCall(`${API_URL}/archigazette`, HomePageActions.SET_HOME_BLOG);
}

function* getStudentPortfolio() {
  try {
    const result = yield call(() => axios.get(`${API_URL}/projects`));
    const { headings, projects } = result.data;

    yield put({
      type: HomePageActions.SET_HOME_STUDENTPORTFOLIO,
      payload: { headings, projects },
    });
  } catch (error) {
    console.error("Error fetching student portfolio:", error);
  }
}

function* getNewsAndEvents() {
  yield* safeApiCall(`${API_URL}/newsandevents`, HomePageActions.SET_HOME_NEWS_AND_EVENTS);
}

function* fetchDetailPage({ payload }) {
  try {
    const { id } = payload;
    const result = yield call(() => axios.get(`${API_URL}/detailednews/${id}`));
    yield put({ type: HomePageActions.SET_DETAILPAGE, payload: result.data });
  } catch (error) {
    console.error("Error fetching detail page:", error);
  }
}

function* StudentPortfolioDetailPage({ payload }) {
  try {
    const { projectId } = payload;
    const result = yield call(() => axios.get(`${API_URL}/detailedprojects/${projectId}`));
    yield put({
      type: HomePageActions.SET_STUDENT_PORTFOLIO_DETAILPAGE,
      payload: result.data,
    });
  } catch (error) {
    console.error("Error fetching project details:", error);
  }
}

function* getListPageBGImage() {
  yield* safeApiCall(`${API_URL}/portfolio_banner`, HomePageActions.SET_LISTPAGE_BACKGROUND_IMAGE);
}

function* getSeoImage() {
  yield* safeApiCall(`${API_URL}/portfolio_banner`, HomePageActions.SET_SEO_IMAGE);
}
